import React, { useState } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Tooltip } from "components";
import * as Icons from "assets/icons";
import useThemeStore from "(store)/themeStore";

const PasswordField = ({
  name,
  label,
  placeholder,
  tooltipValue,
  isRequired = false,
  size = "small",
}) => {
  const { errors, touched } = useFormikContext();
  const theme = useThemeStore((state) => state.theme);
  const showError = touched[name] && errors[name];
  const [showPassword, setShowPassword] = useState(false);

  const isThemeDark = theme === "dark";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="form-control w-full">
      {label && (
        <div className="flex items-center gap-3 mb-1">
          <span className="flex gap-1 items-end relative">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
          {tooltipValue && (
            <Tooltip
              children={<Icons.ExclamationCircleIcon color={"red"} />}
              message={tooltipValue}
            />
          )}
        </div>
      )}
      <div
        className={`relative flex items-center w-full  border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none ${
          isThemeDark
            ? "text-gray-300 focus-within:text-black focus-within:bg-white bg-slate-950 "
            : ""
        } ${
          showError
            ? "focus-within:border-red-500 border-red-500 "
            : `${
                isThemeDark
                  ? "focus-within:border-[#FAB54E]"
                  : "focus-within:border-[#1996A6]"
              }`
        }`}>
        <Field
          name={name}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          className={`flex-grow px-3 ${
            size === "large" ? "py-3" : "py-2"
          } placeholder-[#979797] rounded-md focus:outline-none sm:text-sm ${
            isThemeDark
              ? "text-gray-300 focus-within:bg-white focus-within:text-black bg-slate-950"
              : "text-gray-900 bg-white"
          }`}
          autoComplete="current-password"
        />
        <div className="absolute right-0 top-0 w-12 h-full flex justify-center items-center">
          {showPassword ? (
            <div onClick={togglePasswordVisibility}>
              <Icons.EyeIcon color={theme === "light" ? "black" : "#6b7280"} />
            </div>
          ) : (
            <div onClick={togglePasswordVisibility}>
              <Icons.EyeSlashIcon
                color={theme === "light" ? "black" : "#6b7280"}
              />
            </div>
          )}
        </div>
      </div>
      {showError && (
        <ErrorMessage
          className="text-xs text-red-500 mt-1"
          name={name}
          component="div"
        />
      )}
    </div>
  );
};

export default PasswordField;
